import { power_supply } from './power_supply';

import { ID_GRAPH_AXIS } from '../../constants/idDefinition';
import { CHART_TYPE, SIMULATION_TYPE, UNITS_SIGN } from '../../constants/definitionConstants';

export class ncv4295csn50t1g extends power_supply {
	constructor(opn) {
		super(opn, 'ncv4295c');
		this.SCHEMATIC_DC = require(`../../images/${this.opn}_SCH_DC.svg`);
		this.SCHEMATIC_TRAN = require(`../../images/${this.opn}_SCH_TRAN.svg`);
		this.modelLink = `https://www.${this.domain}/download/models/lib/ncv4295c%20pspice%20model.lib`;
	}

	gainDefinition() {
		const DC_CHART_COLUMN_MAPPING = {
			V_PF: 7
		};
		const TRANSIENT_CHART_COLUMN_MAPPING = {
			TIME: 0,
			TEMP: 1,
			R_LOAD: 2,
			V_IN: 3,
			V_PF: 4,
			V_OUT: 5,
			I_OUT: 6,
			I_GND: 7
		};
		const customizations = {
			simulations: [
				{
					showInputParams: false,
					inputParameters: [
						{
							/**
							 * base heading (heading is created from heading + unit)
							 */
							heading: 'V<sub>IN<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							/**
							 * if unit is not base unit but for example it is in kilo ohm it is needed
							 * to add extension for simulator which tells that it is kilo that’s mean ‘k’
							 */
							netlistUnit: '',
							/**
							 * exact name of parameter from netlist to be replaced
							 */
							mappingName: 'V_INmin',
							minBoundary: 0.5,
							maxBoundary: 22,
							defaultValue: 0.5
						},
						{
							heading: 'V<sub>IN<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'V_INmax',
							minBoundary: 5.5,
							maxBoundary: 23,
							defaultValue: 20
						},
						{
							heading: 'V<sub>IN<sub>(increment)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'V_INstep',
							minBoundary: 0.1,
							maxBoundary: 10,
							defaultValue: 0.5
						},
						{
							heading: 'R<sub>OUT<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.OHM,
							netlistUnit: '',
							mappingName: 'loadMin',
							minBoundary: 209,
							maxBoundary: 5000,
							defaultValue: 225
						},
						{
							heading: 'R<sub>OUT<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.OHM,
							netlistUnit: '',
							mappingName: 'loadMax',
							minBoundary: 210,
							maxBoundary: 5000,
							defaultValue: 1125
						},
						{
							heading: 'R<sub>OUT<sub>(num.steps)</sub></sub>',
							unit: UNITS_SIGN.NOUNITS,
							netlistUnit: '',
							mappingName: 'nLoadSteps',
							minBoundary: 1,
							maxBoundary: 25,
							defaultValue: 4,
							isInteger: true
						},
						{
							heading: 't<sub>ambient<sub>',
							unit: UNITS_SIGN.CELSIUS,
							netlistUnit: '',
							mappingName: 'Tset',
							minBoundary: -40,
							maxBoundary: 150,
							defaultValue: 25,
							displayInput: true
						}
					],
					schematic: {
						schematicPath: this.SCHEMATIC_DC
					},
					charts: [
						{},
						{},
						{},
						{},
						{},
						{
							/**
							 * --------------------------------------------------- PF vs V_IN ---------------------------------------------------
							 */
							id: 'PfVsVin',
							mainHeading:
								'V[baseline-shift: sub; font-size: 11px;]PF[/] = f (V[baseline-shift: sub; font-size: 11px;]IN[/], R[baseline-shift: sub; font-size: 11px;]OUT[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.DC,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'V[baseline-shift: sub; font-size: 11px;]IN[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: this.DC_CHART_COLUMN_MAPPING.V_IN
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]PF[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: DC_CHART_COLUMN_MAPPING.V_PF
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: this.DC_CHART_COLUMN_MAPPING.R_LOAD
							}
						}
					]
				},
				{
					showInputParams: false,
					inputParameters: [
						{
							heading: 'V<sub>IN<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'V_INmin',
							minBoundary: 0.5,
							maxBoundary: 22,
							defaultValue: 0.5
						},
						{
							heading: 'V<sub>IN<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'V_INmax',
							minBoundary: 5.5,
							maxBoundary: 23,
							defaultValue: 20
						},
						{
							heading: 't<sub>rise<sub>V<sub>IN</sub></sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'V_INtr',
							minBoundary: 1,
							maxBoundary: 500,
							defaultValue: 100
						},
						{
							heading: 't<sub>fall<sub>V<sub>IN</sub></sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'V_INtf',
							minBoundary: 1,
							maxBoundary: 500,
							defaultValue: 100
						},
						{
							heading: 't<sub>ON<sub>V<sub>IN</sub></sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'V_INtON',
							minBoundary: 1,
							maxBoundary: 500,
							defaultValue: 300
						},
						{
							heading: 't<sub>step<sub>max</sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'Tstep',
							minBoundary: 1,
							maxBoundary: 100,
							defaultValue: 10
						},
						{
							heading: 'R<sub>OUT<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.OHM,
							netlistUnit: '',
							mappingName: 'loadMin',
							minBoundary: 209,
							maxBoundary: 5000,
							defaultValue: 225
						},
						{
							heading: 'R<sub>OUT<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.OHM,
							netlistUnit: '',
							mappingName: 'loadMax',
							minBoundary: 210,
							maxBoundary: 5000,
							defaultValue: 1050
						},
						{
							heading: 'R<sub>OUT<sub>(num.steps)</sub></sub>',
							unit: UNITS_SIGN.NOUNITS,
							netlistUnit: '',
							mappingName: 'nLoadSteps',
							minBoundary: 1,
							maxBoundary: 6,
							defaultValue: 4,
							isInteger: true
						},
						{
							heading: 'C<sub>IN</sub>',
							unit: UNITS_SIGN.MICRO_FARAD,
							netlistUnit: 'u',
							mappingName: 'Cin',
							minBoundary: 0.1,
							maxBoundary: 10,
							defaultValue: 0.1
						},
						{
							heading: 'ESR<sub>C<sub>IN</sub></sub>',
							unit: UNITS_SIGN.MILLI_OHM,
							netlistUnit: 'm',
							mappingName: 'EsrCin',
							minBoundary: 0,
							maxBoundary: 1000,
							defaultValue: 1
						},
						{
							heading: 'C<sub>OUT</sub>',
							unit: UNITS_SIGN.MICRO_FARAD,
							netlistUnit: 'u',
							mappingName: 'Cout',
							minBoundary: 2.2,
							maxBoundary: 4700,
							defaultValue: 2.2
						},
						{
							heading: 'ESR<sub>C<sub>OUT</sub></sub>',
							unit: UNITS_SIGN.MILLI_OHM,
							netlistUnit: 'm',
							mappingName: 'EsrCout',
							minBoundary: 0,
							maxBoundary: 6000,
							defaultValue: 1
						},
						{
							heading: 't<sub>ambient<sub>',
							unit: UNITS_SIGN.CELSIUS,
							netlistUnit: '',
							mappingName: 'Tset',
							minBoundary: -40,
							maxBoundary: 150,
							defaultValue: 25,
							displayInput: true
						}
					],
					schematic: {
						schematicPath: this.SCHEMATIC_TRAN
					},
					charts: [
						{
							id: 'ComposedChart',
							mainHeading: 'Timing Diagram',
							chartType: CHART_TYPE.COMPOSITE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'Voltage',
									unit: UNITS_SIGN.VOLT
									/*columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_IN
									 */
								}
							],
							composedCharts: [
								{
									id: 'VinVsTime',
									seriesLabel:
										'V[baseline-shift: sub; font-size: 11px;]IN[/] @ R[baseline-shift: sub; font-size: 11px;]OUT[/] = '
								},
								{
									id: 'VpfVsTime',
									seriesLabel:
										'V[baseline-shift: sub; font-size: 11px;]PF[/] @ R[baseline-shift: sub; font-size: 11px;]OUT[/] = '
								},
								{
									id: 'VoutVsTime',
									seriesLabel:
										'V[baseline-shift: sub; font-size: 11px;]OUT[/] @ R[baseline-shift: sub; font-size: 11px;]OUT[/] = '
								}
							],
							series: {
								heading: 'Voltage dependence',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_LOAD
							}
						},
						{
							id: 'VinVsTime',
							mainHeading: 'V[baseline-shift: sub; font-size: 11px;]IN[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]IN[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_IN
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_LOAD
							}
						},
						{
							id: 'VpfVsTime',
							mainHeading: 'V[baseline-shift: sub; font-size: 11px;]PF[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]PF[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_PF
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_LOAD
							}
						},
						{
							id: 'VoutVsTime',
							mainHeading: 'V[baseline-shift: sub; font-size: 11px;]OUT[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]OUT[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_OUT
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_LOAD
							}
						},
						{
							id: 'IoutVsTime',
							mainHeading:
								'I[baseline-shift: sub; font-size: 11px;]OUT[/] = f (t, R[baseline-shift: sub;font-size: 11px;]OUT[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'I[baseline-shift: sub; font-size: 11px;]OUT[/]',
									unit: UNITS_SIGN.AMPER,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.I_OUT
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_LOAD
							}
						},
						{
							id: 'IgndVsTime',
							mainHeading:
								'I[baseline-shift: sub; font-size: 11px;]GND[/] = f (t, R[baseline-shift: sub;font-size: 11px;]OUT[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'I[baseline-shift: sub; font-size: 11px;]GND[/]',
									unit: UNITS_SIGN.AMPER,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.I_GND
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_LOAD
							}
						}
					]
				}
			]
		};
		return super.gainDefinition(customizations);
	}
}
